import React, { useState } from "react";
import { IoIosChatboxes } from "react-icons/io";


const Chat = () => {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const sendMessage = (e) => {
    e.preventDefault();
    if (input.trim() === "") return;

    setMessages([...messages, { text: input, sender: "You" }]);
    setInput("");
  };

  return (
    <div className="fixed bottom-5 right-5">
      {/* Chat Button */}
      {!isOpen && (
        <button
          onClick={() => setIsOpen(true)}
          className="bg-[#007BFF] text-white px-4 py-5 rounded-full shadow-lg hover:bg-[#0056b3] transition duration-300"
        >
<IoIosChatboxes className='w-10 h-10' />
        </button>
      )}

      {/* Chat Box */}
      {isOpen && (
        <div className="w-80 bg-white border rounded-lg shadow-lg overflow-hidden">
          {/* Chat Header */}
          <div className="bg-orange-600 text-white p-3 flex justify-between">
            <h2 className="text-lg font-bold">Chat</h2>
            <button onClick={() => setIsOpen(false)}>✖</button>
          </div>

          {/* Messages */}
          <div className="h-60 overflow-y-auto p-3">
            {messages.length === 0 ? (
              <p className="text-gray-500 text-center">Start chatting!</p>
            ) : (
              messages.map((msg, index) => (
                <div
                  key={index}
                  className={`p-2 my-2 w-fit max-w-xs rounded-lg ${
                    msg.sender === "You"
                      ? "bg-orange-500 text-white ml-auto"
                      : "bg-gray-200 text-black"
                  }`}
                >
                  <strong>{msg.sender}:</strong> {msg.text}
                </div>
              ))
            )}
          </div>

          {/* Input Box */}
          <form className="flex p-3 border-t" onSubmit={sendMessage}>
            <input
              type="text"
              className="flex-1 p-2 border rounded-l-md outline-none"
              placeholder="Type a message..."
              value={input}
              onChange={(e) => setInput(e.target.value)}
            />
            <button
              type="submit"
              className="bg-orange-500 text-white px-4 py-2 rounded-r-md hover:bg-orange-600"
            >
              Send
            </button>
          </form>
        </div>
      )}
    </div>
  );
};

export default Chat;
